import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import { translate } from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';

import { distributionReturnedSearch, distributionReturned, lookupsOrderBy, distributionReturnedSearchByUnit } from '../../../libs/services';
import { FloatingActionButton } from 'material-ui';
import SvgIcon from 'react-icons-kit';
import { search } from 'react-icons-kit/icomoon/search';
import { bin } from 'react-icons-kit/icomoon/bin';

var Config = require('../../../config');

class ComponentReturnForm extends Component{
    constructor(props){
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.dateCompare = this.dateCompare.bind(this);
        this.onCheck = this.onCheck.bind(this);
        this.onSave = this.onSave.bind(this);

        this.state = {
            filterText: "",
            list:[],
            start_date:"",
            end_date:"",
            folio:"",
            observations:"",
            search_type:"",
            reason:"",
            reasons:[]
        }
    }

    async componentDidMount(){
        var res = await lookupsOrderBy('REFOUND_PETITON_REASONS');

        if(res !== undefined){
            this.setState({reasons: res});
        }
    }

    handleChange(e){
        this.setState({[e.target.name]: e.target.value});

        if(e.target.name === 'search_type'){
            this.setState({
                start_date:"",
                end_date:"",
                folio:"",
                observations:"",
            });
        }
    }

    filter(row){
		var res = true;

		var string = row.shipping_folio + ' ' + row.center_name + ' ' + row.unit_number + ' ' 
            + row.unit_component + ' ' + row.unit_component_number + row.unit_volume;

		if(row !== null){
			if(string.indexOf(this.state.filterText.toUpperCase()) !== -1){
				res = true;
			}else{
				res = false;
			}
		}

		return res;
	}

    async onSearch(){
        var error = '';
        
        if(this.state.search_type === 'date'){
            if(!this.dateCompare()){
                error = 'La Fecha Hasta debe ser mayor o igual a Fecha Desde'
            }

            if(this.state.start_date === "" && this.state.end_date === ""){
                error = 'Debe seleccionar una fecha inicial y fecha final';
            }
        }else if(this.state.search_type === 'unit'){
            if(this.state.unit === ""){
                error = 'Debe agregar un numero de unidad'
            }
        }else{
            if(this.state.folio === ""){
                error = 'Debe agregar un folio'
            }
        }
        

        if(error === ''){
            var request;
            if(this.state.search_type === 'unit'){
                request = await distributionReturnedSearchByUnit(this.state.unit, sessionStorage.getItem('health_facilities_id'), this.props.waiting);

                var list = this.state.list;
                request.forEach((req)=>{
                    req.check = false;

                    var index = list.findIndex(item => item.unit_id === req.unit_id);

                    if(index === -1){
                        list.push(req);
                    }
                    
                });

                this.setState({list, unit:""});                

            }else{
                request = await distributionReturnedSearch(
                                this.state.start_date, 
                                this.state.end_date, 
                                this.state.folio,
                                sessionStorage.getItem('health_facilities_id'), 
                                this.props.waiting
                            );
                
                if(request !== undefined){
                    request.forEach((req)=>{
                        req.check = false;
                    });
    
                    this.setState({list: request});
                }
            
            }

        }else{
            swal('Error', error, 'error');
        }
    }

    dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;

		if(ini !== 'Invalid date' && fin !== 'Invalid date'){
			if(fin < ini){
				date_ok = false;
				document.getElementById('end_date').classList.add('error');
			}else{
				document.getElementById('end_date').classList.remove('error');
			}
		}else{
			date_ok = false;
		}		

		return date_ok;
	}

    onCheck(e, i){
        var list = this.state.list;
        list[i].check = e.target.checked;

        this.setState({list: list});
    }

    async onSave(e){
        e.preventDefault();

        var obj = {
            return_reason:this.state.reason,
            observations: this.state.observations,
            health_facilities_id: sessionStorage.getItem('health_facilities_id'),
            distribution_returned_units:[]
        };

        this.state.list.forEach((list)=>{
            if(list.check){
                obj.distribution_returned_units.push({
                    unit_id: list.unit_id,
                    shipping_date: list.shipping_date,
                    unit_export_id: list.unit_export_id,
                    unit_request_id: list.unit_request_id
                });
            }
        });

        if(obj.distribution_returned_units.length > 0){
            var res = await distributionReturned(obj, this.props.waiting);

            if(res){
                this.props.history.goBack();
            }
        }
    }

    render(){
        const {t} = this.props;

        return(
            <div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')+ ' -> '}
						{t('sidebar.nav.home.MAIN') + ' -> '}
						{t('sidebar.nav.distribution.MAIN') +' -> '}
						Devolución de Componentes {' -> '} Buscar Envío
					</h5>
				</div>

                <div className='form-group'>
                    <div className='col-xs-12 form-group'>
                        <div className='col-xs-12 col-sm-2'>
                            <span className='span-min'>Buscar por</span>
                            <select name="search_type" id="search_type" value={this.state.search_type}
                                onChange={(e)=>this.handleChange(e)} className="form-control">
                                <option value="">Seleccione...</option>
                                <option value="folio">Folio de envio</option>
                                <option value="date">Fecha de envio</option>
                                <option value="unit">Unidad</option>
                            </select>
                        </div>
                        {this.state.search_type === 'date' &&
                            <>
                                <div className='col-xs-12 col-sm-1'>
                                    <span className='span-min'>Fecha Desde</span>
                                    <input type="date" name="start_date" id="start_date" value={this.state.start_date} 
                                        onChange={(e)=>this.handleChange(e)} className='form-control hour-input' />
                                </div>
                                <div className='col-xs-12 col-sm-1'>
                                    <span className='span-min'>Fecha Hasta</span>
                                    <input type="date" name="end_date" id="end_date" value={this.state.end_date} 
                                        onChange={(e)=>this.handleChange(e)} className='form-control hour-input' />
                                </div>
                            </>
                        }
                        
                        {this.state.search_type === 'folio' &&
                            <>
                                <div className='col-xs-12 col-sm-1'>
                                    <span className='span-min'>Folio</span>
                                    <input name='folio' id='folio' value={this.state.folio} onChange={(e)=>this.handleChange(e)}
                                        className="form-control" />
                                </div>
                            </>
                        }

                        {this.state.search_type === 'unit' &&
                            <>
                                <div className='col-xs-12 col-sm-1'>
                                    <span className='span-min'>Unidad</span>
                                    <input name='unit' id='unit' value={this.state.unit} onChange={(e)=>this.handleChange(e)}
                                        className="form-control" />
                                </div>
                            </>
                        }

                        <div className='col-xs-12 col-sm-6' style={{marginTop:18}}>
                            <button className='btn btn-info' onClick={()=>this.onSearch()}>Buscar</button>                            
                        </div>
                    </div>
                    <div className='col-xs-12 form-group'>
                        <div className='col-xs-12 col-sm-2'>
                            <span className='span-min'>Motivo de Devolución</span>
                            <select className='form-control' name="reason" id='reason' value={this.state.reason}
                                onChange={(e)=>this.handleChange(e)}
                            >
                                <option value=''>Seleccione...</option>
                                {this.state.reasons.map((reason, i)=>
                                    <option key={i} value={reason.key}>{reason.name}</option>
                                )}
                            </select>
                        </div>
                    </div>
                    <div className='col-xs-12 form-group'>
                        <div className='col-xs-12 col-sm-6'>
                            <span className='span-min'>Observaciones</span>
                            <textarea name='observations' rows={4} id='observations' value={this.state.observations} onChange={(e)=>this.handleChange(e)} className="form-control"
                                style={{resize:'none'}}
                            ></textarea>
                        </div>
                    </div>
                    <div className='col-xs-12 form-group'>
                        <div className="col-xs-12 col-sm-2">
							<span className="span-min">Filtro</span>
							<input type="text" className="form-control" placeholder="Filtro..." name="filterText" 
								value={this.state.filterText} onChange={this.handleChange} />
						</div>
                    </div>
                    <div className='col-xs-12 form-group'>
                        <Table responsive hover>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Fecha de Envío</th>
                                    <th>Folio de Envío</th>
                                    <th>Centro</th>
                                    <th>No. Unidad</th>
                                    <th>Componente</th>
                                    <th>No. Componente</th>
                                    <th>Volumen</th>
                                    <th>Fecha Caducidad</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.list.map((list, i)=> {
                                    return this.filter(list) ?
                                    <tr key={i}>
                                        <td>
                                            <input type='checkbox' onChange={(e)=>this.onCheck(e, i)} />
                                        </td>
                                        <td>{moment(list.shipping_date).format('DD/MM/YYYY')}</td>
                                        <td>{list.shipping_folio}</td>
                                        <td>{list.center_name}</td>
                                        <td>{list.unit_number}</td>
                                        <td>{list.unit_component}</td>
                                        <td>{list.unit_component_number}</td>
                                        <td>{list.unit_volume}</td>
                                        <td>{moment(list.unit_expiration).format('DD/MM/YYYY')}</td>
                                    </tr>
                                    : null
                                })}
                            </tbody>
                        </Table>
                    </div>

                    <div className='col-xs-12' style={{textAlign:'center'}}>
                        <button className='btn btn-info' onClick={()=>this.props.history.goBack()}>Cancelar</button>
                        <button className='btn btn-info' style={{marginLeft:8}} onClick={(e)=>this.onSave(e)}>Guardar</button>
                    </div> 
                </div>
            </div>
        )
    }
    
}

export default translate('translations')(ComponentReturnForm);